/**
 * Firebase userプロパティ関連の定数・変換（依頼書 §2-1）。
 * nativeBridge から import されるため、循環参照を避けて依存ゼロで独立させている。
 */

/** 共通計測モジュールのバージョン。userプロパティ sdk_version としてネイティブへ渡す */
export const FIREBASE_ANALYTICS_SDK_VERSION = "1.0.0";

/**
 * login API の gender(0=男性, 1=女性) を Firebase userプロパティ用の文字列へ変換する。
 * 依頼書 §2-1: 変換は共通モジュール内のこの1箇所のみ。生の 0/1 を送らない。
 */
export const toFirebaseGender = (gender: number): "male" | "female" => {
  return gender === 1 ? "female" : "male";
};
